// BUG-146: 서비스 errorCode 정규화. None 옵션('-' 코드) 선택만 빈 문자열로,
// 그 외 값은 그대로 보존(하이픈 포함 정상 코드 예: E-001 훼손 방지).
export const normalizeErrorCode = (value) => (value === '-' ? '' : value);
